export const TAX_CODE_REFERENCE_URL =
  'https://docs.commenda.io/engine/indirect-tax/taxcode';

export const SALES_TAX_TABLE_IDS = {
  TRANSACTIONS: 'transactions',
  PRODUCTS: 'products',
  CALCULATIONS: 'calculations',
  FILINGS: 'filings',
  CUSTOMERS: 'customers',
  EXEMPTION_CERTIFICATES: 'exemption-certificates',
} as const;
